import styled from 'styled-components';

const KPITrendStyled = styled.div`
  background: #ffffff;
  margin-top: 12px;
  border-radius: 12px;
  padding: 30px;
  .isChanged {
    background: #1d8fc0;
    color: #ffffff;
  }
  .Mui-selected {
    background: #1d8fc0 !important;
    color: #ffffff;
  }
  .noChange {
    border: 1px solid #f6f6f6;
    background: #fafafa;
  }
  .sales-icon-wrap {
    display: flex;
    align-items: center;
    div {
      margin-left: 12px;
      font-family: 'SourceHanSansCNMedium', sans-serif;
      font-size: 18px;
      font-weight: 500;
      color: #424242;
      line-height: 27px;
    }
  }
  .trend-wrap {
    display: flex;
    flex-direction: row;
    width: 100%;
    gap: 64px;
    .trend-left {
      /* padding: 30px 0 0 30px; */
      font-size: 18px;
      font-weight: bold;
      color: #424242;
      line-height: 22px;
    }
    .condition-wrap {
      width: 496px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 8px 0 0 32px;
      div:nth-child(2n + 1) {
        margin-right: 23px;
      }
      li {
        font-size: 16px;
        font-family: 'SourceHanSansCNRegular', sans-serif;
        font-weight: 400;
        line-height: 24px;
      }
      .condition-item-wrap {
        width: 209px;
        border-radius: 6px;
        margin-top: 9px;
        .icon-divider {
          width: 1px;
          height: 15px;
          background: #f2f3f6;
          margin: 0 11px 0 12px;
        }
      }
    }
    .trend-right {
      flex: 1 auto;
      /* height: 239px; */
      /* padding: 30px 24px 23px 33px; */
      overflow: hidden;
      position: relative;
    }
  }
  .nodata-wrap {
    height: 50%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
  }
`;

export default KPITrendStyled;
